import { useIsMobile } from '@sravni/react-utils';
import { useEffect, useRef } from 'react';
import { useFormContext } from 'react-hook-form';

import { formatToOnlyDigit } from 'commonUtils/formatters/formatToOnlyDigit';

import { CONFIRMATION_FORM_FIELDS } from './PreApprovalConfirmationForm.config';
import type { ConfirmationFormValues } from './schema';

type Params = {
  isFormDisabled: boolean;
  submit: () => void | Promise<void>;
  codeLength?: number;
};

export const useAutoSubmitSmsCodeOnDesktop = ({ isFormDisabled, submit, codeLength = 4 }: Params) => {
  const isMobile = useIsMobile();
  const { watch } = useFormContext<ConfirmationFormValues>();
  const smsCodeValue = watch(CONFIRMATION_FORM_FIELDS.SMS_CODE);
  const lastAutoSubmittedCodeRef = useRef<string | null>(null);

  useEffect(() => {
    if (isMobile || isFormDisabled) {
      return;
    }

    const digitsOnly = formatToOnlyDigit(smsCodeValue);

    if (digitsOnly.length !== codeLength) {
      lastAutoSubmittedCodeRef.current = null;
      return;
    }

    if (lastAutoSubmittedCodeRef.current === digitsOnly) {
      return;
    }

    lastAutoSubmittedCodeRef.current = digitsOnly;

    submit();
  }, [codeLength, isFormDisabled, isMobile, smsCodeValue, submit]);
};
